import React from 'react';
import Card from '../UI/Card';

interface OrderSummaryProps {
  items: Array<{
    name: string;
    price: string;
  }>;
  total: string;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ items, total }) => {
  return (
    <Card className="p-4">
      <h3 className="font-semibold text-gray-800 dark:text-gray-100 mb-3">Order Summary</h3>
      <div className="space-y-2">
        {items.map((item, index) => (
          <div key={index} className="flex justify-between items-center">
            <span className="text-gray-600 dark:text-gray-300">{item.name}</span>
            <span className="font-semibold text-gray-800 dark:text-gray-100">{item.price}</span>
          </div>
        ))}
      </div>
      <div className="flex justify-between items-center pt-3 mt-3 border-t border-gray-200 dark:border-gray-600">
        <span className="font-semibold text-gray-800 dark:text-gray-100">Total</span>
        <span className="font-bold text-lg text-purple-600 dark:text-purple-400">{total}</span>
      </div>
    </Card>
  );
};

export default OrderSummary;